import { render, staticRenderFns } from "./sales-analytics.vue?vue&type=template&id=f6a6797a&"
import script from "./sales-analytics.vue?vue&type=script&lang=js&"
export * from "./sales-analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports